module.exports = __webpack_public_path__ + "img/Vincent_Headshot-photoaidcom-cropped.c7c85a34.JPG";